import React, { useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotA404 = () => {
    
    useLayoutEffect(() => {
        window.scrollTo(0, 0)
    });
    const { t } = useTranslation();
    const location = useLocation();
    const isEnglish = location.pathname.startsWith("/en");

    return (
        <section className='notA404'>
            <Link to={isEnglish ? "/en" : "/"}>
                <div>
                    <img src="../../assets/img/logonav.png" alt="YASKIA" title="YASKIA"/>
                </div>
            </Link>
            <h4>
                {t("404.h4")}
            </h4>
            <Link to={isEnglish ? "/en" : "/"} className="btn404">
                {t("404.btn")}
            </Link>
        </section>
    )
}

export default NotA404